@if (attributeDetail$ | async) {
  <div>
    <form [formGroup]="form">
      <div    class="flex-gap-6vw flex-space-between-center flex-row">
        <label class="mt-4">JSON&nbsp;Attribute Name</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="jsonProperty"
            type="text"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-12-5vw flex-space-between-center flex-row">
        <label class="mt-4">Name</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="name"
            type="text"
            required
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-10vw flex-space-between-center flex-row">
        <label class="mt-4">Description</label>
        <mat-form-field class="flex-40" >
          <textarea matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="3"
            formControlName="description"
            type="text"
          ></textarea>
        </mat-form-field>
      </div>
      <div    class="flex-gap-12-35vw flex-space-between-center flex-row">
        <label class="mt-4">Scope</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="scope"
            type="select"
            >
            <mat-option [value]="'GLOBAL'" [disabled]="true">
              Global
            </mat-option>
            <mat-option [value]="'LOCALE'" [disabled]="true">
              Locale
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      @if (form.controls['scope'].value === 'GLOBAL') {
        <div
          class="flex-gap-12-35vw flex-space-between-center flex-row">
          <label class="mt-4">Item Type Scope</label>
          <mat-form-field class="flex-40" >
            <mat-select
              [attr.data-testid]="'item_type_scope_select'"
              formControlName="itemTypeScope"
              placeholder="Item Type Scope"
              required
              multiple
              >
              <mat-option
                (click)="toggleSelectAll()"
                #allSelected
                [value]="'0'"
                >
                Select All
              </mat-option>
              @for (typeValues of itemTypes; track typeValues) {
                <mat-option
                  [attr.data-testid]="typeValues.tag + '_option'"
                  [value]="typeValues.tag"
                  (click)="toggleSelectOne()"
                >{{ typeValues.value }}</mat-option>
              }
            </mat-select>
            @if (form.controls['itemTypeScope'].invalid) {
              <mat-error>
                Please Select a Value
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      <div    class="flex-gap-9-35vw flex-space-between-center flex-row">
        <label class="mt-4">Region&nbsp;Scope</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="regionScope"
            type="select"
            >
            <mat-option [value]="'GLOBAL'" [disabled]="true">
              Global
            </mat-option>
            <mat-option [value]="'LOCALE'" [disabled]="true">
              Locale
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div    class="flex-gap-9vw flex-space-between-center flex-row">
        <label class="mt-4">Attribute&nbsp;Type</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="type"
            type="select"
            >
            @for (option of attributeTypes$ | async; track option) {
              <mat-option [value]="option.tag"
                [disabled]="true">
                {{ option.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div    class="flex-gap-11-25vw flex-space-between-center flex-row">
        <label class="mt-4">Required</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="required"
            type="select"
            >
            <mat-option [value]="true" [disabled]="true">
              True
            </mat-option>
            <mat-option [value]="false" [disabled]="true">
              False
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div    class="flex-gap-12vw flex-space-between-center flex-row">
        <label class="mt-4">Locked</label>
        <mat-form-field class="flex-40" >
          <mat-select
            formControlName="locked"
            type="select"
            >
            <mat-option [value]="true" [disabled]="true">
              True
            </mat-option>
            <mat-option [value]="false" [disabled]="true">
              False
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div    class="flex-gap-10-25vw flex-space-between-center flex-row">
        <label class="mt-4">Sort&nbsp;Weight</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="sortOrder"
            type="number"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-9-75vw flex-space-between-center flex-row">
        <label class="mt-4">Default&nbsp;Value</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="defaultValue"
            type="text"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-7vw flex-space-between-center flex-row">
        <label class="mt-4">Validation Expression</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="validationExpression"
            type="text"
            >
        </mat-form-field>
      </div>
      <div    class="flex-gap-9-75vw flex-space-between-center flex-row">
        <label class="mt-4">Attribute Group</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="attributeGroup"
            type="text"
            >
        </mat-form-field>
      </div>
      @if ((attributeDetails.type === 'SELECT' || attributeDetails.type === 'MULTI_SELECT') &&
        attributeDetails.type !== 'BOOL') {
        <div
          class="flex-gap-9-75vw flex-space-between-center flex-row">
          <label class="mt-4">Options</label>
          <mat-form-field class="flex-40" >
            <mat-select
              formControlName="options"
              type="select"
              >
              @for (option of attributeDetails?.options; track option) {
                <mat-option [value]="option.tag"
                  [disabled]="true">
                  {{option.label}}
                </mat-option>
              }
              <mat-option (click)="addNewOptions()">
                <mat-icon>add</mat-icon>Add new options
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div    class="flex-gap-9-75vw flex-space-between-center flex-row">
        <label class="mt-4">Locale Support</label>
        <mat-form-field class="flex-40" >
          <input matInput
            formControlName="localeSupport"
            type="select"
            >
        </mat-form-field>
      </div>
    </form>
    @if (attributeDetail$ | async; as item) {
      <emm-attribute-updated-info
        [lastUpdatedBy]="item.updatedBy"
        [lastUpdatedDate]="item.dateUpdated"
      ></emm-attribute-updated-info>
    }
  </div>
}
